import React, { Component } from "react";
import { toast } from "react-toastify";
import ApiConnect from "../../../../Utils/ApiConnect";
import ProductAutoComplete from "../Components/ProductAutoComplete";
import { connect } from "react-redux";
import {
  SalesChangeHandler,
  SalesAddParticular,
  removeSalesParticular,
  SalesSetToDefault,
} from "../../../../redux/actions/Sales.Action";
import moment from "moment";
import DatePicker from "react-datepicker";

import BarcodeScanner from "../../../Components/BarcodeScanner";
import AutoComplete from "../../../Components/AutoComplete";
class PurchaseEntry extends Component {
  state = {
    product: "",
    id: "",
    qty: 0,
    free: 0,
    rate: 0,
    tax: 0,
    taxAmt: 0,
    netAmt: 0,
    remainQty: 0,
    stock: 0,
    reset: false,
    resetAccount: false,
    formError: false,
    accountHead: false,
    ProductList: false,
    previewImage: [],
    date: "",
    btnDisable: false,
    docs: [],
  };
  componentDidMount() {
    this.fetchPurchaseData();
    this.props.SalesSetToDefault();
  }
  fetchPurchaseData() {
    ApiConnect.get(`/Module/SalesPurchase/Purchase/PurchaseData`)
      .then((response) => {
        this.setState({
          accountHead: response.data.account,
          ProductList: response.data.products,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  imageHandleChange(e) {
    if (e.target.files) {
      const fileArray = Array.from(e.target.files).map((file) =>
        URL.createObjectURL(file)
      );
      this.setState({ docs: e.target.files, previewImage: fileArray });
    }
  }

  setSelectedAccount = (e) => {
    this.setState({ selAccount: e });
  };

  handleSubmit = (e) => {
    this.CalculateNetAmt(e);
    if ((e.charCode === 13 || e.type === "click") && this.state.rate !== 0) {
      this.props.SalesAddParticular(this.state);
      this.setState({
        product: "",
        id: "",
        qty: 0,
        free: 0,
        rate: 0,
        tax: 0,
        taxAmt: 0,
        netAmt: 0,
        remainQty: 0,
        reset: true,
        stock: 0,
        formError: false,
      });
    } else if (!this.state.rate) {
      this.setState({ formError: "Product Rate Required." });
    }
  };
  ProductChange = (e) => {
    ApiConnect.get(
      `/Module/Inventory/Product/Rate?id=${e.id}&route=${this.props.SalesData.route}&type=${this.props.SalesData.rate}&party=${this.props.SalesData.account.id}`
    )
      .then((response) => {
        this.setState({
          rate: parseFloat(response.data.cost_price),
          remainQty: parseFloat(response.data.stock),
          stock: parseFloat(response.data.stock),
        });
      })
      .catch((error) => {
        console.log(error);
      });
    this.setState({
      product: e.name,
      id: e.id,
      tax: parseFloat(e.vat),
    });
  };
  CalculateNetAmt = (e) => {
    let TotalQty = 0;
    let NetAmt = 0;
    let TaxAmt = 0;
    let tempState = { ...this.state };
    const val = parseFloat(e.target.value || 0);
    tempState[e.target.name] = e.target.value;
    if (e.target.name === "qty") {
      TotalQty = parseFloat(this.state.free + val);
      NetAmt = val * this.state.rate;
    }
    if (e.target.name === "free") {
      TotalQty = this.state.qty + val;
      NetAmt = this.state.qty * this.state.rate;
    }
    if (e.target.name === "rate") {
      TotalQty = parseFloat(this.state.qty) + parseFloat(this.state.free);
      NetAmt = TotalQty * val;
    }
    TaxAmt = parseFloat((this.state.tax * NetAmt) / 100);
    tempState["remainQty"] = parseFloat(this.state.stock - TotalQty).toFixed(2);
    tempState["netAmt"] = parseFloat(NetAmt + TaxAmt).toFixed(2);
    tempState["taxAmt"] = TaxAmt;
    this.setState(tempState);
  };
  ChangeProductStatus = () => {
    this.setState({ reset: false });
  };
  resetSelectedAccount = () => {
    this.setState({ resetAccount: false });
  };
  handleSalesSubmit = () => {
    this.setState({ btnDisable: true });
    const SalesData = this.props.SalesData;
    const particular = SalesData.particulars;
    var Fdata = new FormData();
    Fdata.append(
      "date",
      this.state.date ? moment(this.state.date).format("Y-MM-DD") : ""
    );
    Fdata.append("account", SalesData.account.id);
    Fdata.append("type", SalesData.type);
    particular.forEach((x) => {
      Fdata.append("product[]", x.name);
      Fdata.append("id[]", x.id);
      Fdata.append("qty[]", x.qty);
      Fdata.append("rate[]", x.rate);
      Fdata.append("free[]", x.free);
      Fdata.append("tax[]", x.tax);
      Fdata.append("taxAmount[]", x.taxAmt);
      Fdata.append("productGross[]", x.netAmt);
    });
    Fdata.append("subTotal", SalesData.netAmount);
    Fdata.append("companyTax", SalesData.tax);
    Fdata.append("CompanyTaxAmount", SalesData.taxAmount);
    Fdata.append("Total", SalesData.grandTotal);
    Fdata.append("note", SalesData.remark);
    Fdata.append("payment", SalesData.remark);
    Fdata.append("amountReceive", SalesData.remark);
    Fdata.append("note", SalesData.remark);
    for (let i = 0; i < this.state.docs.length; i++) {
      Fdata.append("images_files[]", this.state.docs[i]);
    }
    ApiConnect({
      method: "post",
      url: "/Module/SalesPurchase/Purchase/NewPurchase",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            formError: false,
            product: "",
            id: "",
            qty: 1,
            free: 0,
            rate: 0,
            tax: 0,
            taxAmt: 0,
            netAmt: 0,
            remainQty: 0,
            stock: 0,
            reset: false,
            resetAccount: true,
            date: "",
            previewImage: [],
            btnDisable: false,
            docs: [],
          });
          this.props.SalesSetToDefault();
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  };
  render() {
    const SalesData = this.props.SalesData;
    const AccountData = this.props.AccountData;
    return (
      <>
        <div className="card">
          <div className="card-title">
            <div className="d-flex">
              <h5>Purchase Entry</h5>
            </div>
          </div>
          <div className="card-body">
            <div className="row ">
              <div className="col-md-4 pb-3">
                {this.state.accountHead ? (
                  <div className="form-group">
                    <label>Account Head *</label>
                    <AutoComplete
                      action={this.props.SalesChangeHandler}
                      name="account"
                      value={AccountData.name}
                      default={this.state.resetAccount}
                      defaultFallback={this.resetSelectedAccount}
                      placeHolder="Account Head"
                      styleName="form-control input-sm d-block"
                      items={this.state.accountHead}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="row form-group">
                  <div className="col">
                    <label>Date *</label>
                    <DatePicker
                      dateFormat="yyyy-MM-dd"
                      className="form-control"
                      disabledKeyboardNavigation
                      name="date"
                      maxDate={new Date()}
                      closeOnScroll={true}
                      selected={this.state.date}
                      value={new Date()}
                      onChange={(e) => {
                        this.setState({ date: e });
                      }}
                      withPortal
                      placeholderText="Select Date"
                    />
                  </div>
                  <div className="col">
                    <label>Type</label>
                    <select
                      className="form-control"
                      name="type"
                      onChange={(e) => this.props.SalesChangeHandler(e)}
                      value={SalesData.type}
                    >
                      <option value="">----Select Type----</option>
                      <option value="Estimate">Estimate</option>
                      <option value="Invoice">Invoice</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 pb-3">
                <div className="row form-group">
                  <div className="col">
                    <label>Applied Rate</label>
                    <select
                      className="form-control"
                      name="rate"
                      onChange={(e) => this.props.SalesChangeHandler(e)}
                      value={SalesData.rate}
                    >
                      <option value="">Select Applied</option>
                      <option value="route">Route</option>
                      <option value="Salesman">Salesman</option>
                      <option value="Retail">Retail</option>
                    </select>
                  </div>
                  <div className="col">
                    <label>Route</label>
                    <select className="form-control">
                      <option value="">----Select Route----</option>
                    </select>
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col">
                    <label>Payment Type</label>
                    <select
                      className="form-control"
                      name="payment"
                      onChange={(e) => this.props.SalesChangeHandler(e)}
                      value={SalesData.payment}
                    >
                      <option value="">---Payment Type---</option>
                      <option value="Credit">Credit</option>
                      <option value="Cash">Cash</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="col">
                    <label>Tax Applied</label>
                    <select
                      name="tax"
                      onChange={(e) => this.props.SalesChangeHandler(e)}
                      defaultValue={SalesData.tax}
                      className="form-control"
                    >
                      <option value={0}>Not Applied</option>
                      <option value={13}>13% Applied</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-4 pb-3">
                <address>
                  <strong>{AccountData.group || ""}</strong>
                  <br />
                  <b>Address: </b>
                  {AccountData.address || ""}
                  <br />
                  <b>Contact: </b> {AccountData.contact || ""}
                  <br />
                  <strong>Due: {AccountData.balance || ""}/</strong>
                  <br />
                  <b>Last Credit: </b>
                  {AccountData.lastCredit || ""}
                  <br />
                  <b>Last Debit: </b>
                  {AccountData.lastDebit || ""}
                </address>
              </div>
            </div>
          </div>
        </div>

        <BarcodeScanner value="" fallback="" />
        <div className="card ">
          <div
            className="row card-body"
            style={{ display: !AccountData.name ? "none" : "" }}
          >
            <p className="text-danger">{this.state.formError}</p>
            <div className="row justify-content-center">
              <div className="form-group col-lg-3">
                <label>Product</label>
                {this.state.ProductList && (
                  <ProductAutoComplete
                    action={this.ProductChange}
                    name="product"
                    default={this.state.reset}
                    defaultFallback={this.ChangeProductStatus}
                    placeHolder="Scan / search products by code / name"
                    items={this.state.ProductList}
                  />
                )}
              </div>
              <div className="form-group row col-lg-3">
                <div className="col">
                  <label>
                    Qty *{" "}
                    <span
                      className={`badge ${
                        this.state.remainQty > 0
                          ? "badge-success"
                          : "badge-danger"
                      } text-white`}
                    >
                      {this.state.remainQty || 0}
                    </span>
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      onChange={(e) => this.CalculateNetAmt(e)}
                      onKeyPress={(e) => this.handleSubmit(e)}
                      value={this.state.qty}
                      step="0.01"
                      name="qty"
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="col">
                  <label>Rate *</label>
                  <input
                    type={"number"}
                    value={this.state.rate}
                    name="rate"
                    onKeyPress={(e) => this.handleSubmit(e)}
                    onChange={(e) => this.CalculateNetAmt(e)}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group row col-lg-3">
                <div className="col">
                  <strong>Free</strong>
                  <input
                    type="number"
                    value={this.state.free}
                    step="0.01"
                    onChange={(e) => this.CalculateNetAmt(e)}
                    onKeyPress={(e) => this.handleSubmit(e)}
                    name="free"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col">
                  <label>
                    Tax * <span>{this.state.tax}%</span>{" "}
                    <span className={`badge  text-white`}>
                      {this.state.tax || 0}
                    </span>
                  </label>
                  <input
                    type={"number"}
                    value={this.state.taxAmt}
                    disabled={true}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group row col-lg-3">
                <div className="col">
                  <label>Net.Amt</label>
                  <input
                    type={"number"}
                    value={this.state.netAmt}
                    disabled={true}
                    className="form-control"
                  />
                </div>
                <div className="col">
                  <label>Action</label>
                  <br />
                  <button
                    onClick={(e) => this.handleSubmit(e)}
                    className="btn btn-square btn-success text-center"
                  >
                    <span className="material-icons-outlined">add</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="row">
              {this.props.Particulars.length !== 0 ? (
                <table className="table table-separated table-sm">
                  <thead>
                    <tr>
                      <th classs="text-center">SN</th>
                      <th>Product</th>
                      <th>Qty</th>
                      <th>Rate</th>
                      <th>Free</th>
                      <th>Tax</th>
                      <th>Net.Amt</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.Particulars.map((particular, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="col-3">{particular.name}</td>
                        <td className="col-2"> {particular.qty}</td>
                        <td>{particular.rate}</td>
                        <td className="col-1">{particular.free}</td>
                        <td>{particular.taxAmt}</td>
                        <td> {particular.netAmt}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-square btn-danger"
                            id="addMore"
                            onClick={() =>
                              this.props.removeSalesParticular(particular)
                            }
                          >
                            <span className="material-icons-outlined">
                              clear
                            </span>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="card">
          <div className="row card-body">
            <div className="col-md-4">
              <p
                className="text-muted well well-sm no-shadow"
                style={{ marginTop: 10 }}
              >
                <textarea
                  className="form-control"
                  rows={3}
                  placeholder="Narrator"
                  name="notes"
                  onChange={(e) => this.props.SalesChangeHandler(e)}
                  defaultValue={this.props.SalesData.remark}
                />
              </p>
            </div>
            <div className="col-md-3">
              <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h6 className="mb-0 fw-bold ">Images</h6>
              </div>
              <div className="card-body">
                <div className="file-group">
                  <input
                    type="file"
                    id="file"
                    multiple
                    accept="image/*"
                    onChange={(e) => this.imageHandleChange(e)}
                    required
                  />
                  <label htmlFor="file">
                    <span className="material-icons-outlined">upload_file</span>
                  </label>
                </div>
                <div className="row">
                  {this.state.previewImage.map((image, index) => (
                    <div className="col" key={index}>
                      <img
                        className="img-thumbnail"
                        width="150"
                        src={image}
                        alt={`doc${index}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <p className="lead">
                Amount Due{" "}
                <span>
                  {" "}
                  {AccountData.length !== 0
                    ? AccountData.balance +
                      this.state.totalAmt -
                      this.state.cashReceive
                    : "0"}
                </span>
              </p>
              <div className="table-responsive">
                <table className="table table-condensed">
                  <tbody>
                    <tr>
                      <th>Subtotal:</th>
                      <td>{this.props.SalesData.netAmount}</td>
                    </tr>
                    <tr>
                      <th>Tax ({this.props.SalesData.tax})%</th>
                      <td>{this.props.SalesData.taxAmount}</td>
                    </tr>
                    <tr>
                      <th>Total:</th>
                      <td>{this.props.SalesData.grandTotal}</td>
                    </tr>
                    <tr
                      style={{
                        display:
                          this.props.SalesData.payment === "Credit"
                            ? "none"
                            : "",
                      }}
                    >
                      <th>Amount Received</th>
                      <td>
                        <input
                          type="number"
                          name="AmountReceive"
                          onChange={(e) => this.props.SalesChangeHandler(e)}
                          value={SalesData.AmountReceive}
                          className="form-control"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <footer className="card-footer">
            <button
              className="btn btn-success w-100"
              type="button"
              disabled={this.state.btnDisable}
              onClick={() => this.handleSalesSubmit()}
            >
              Submit Entries
            </button>
          </footer>
        </div>
      </>
    );
  }
}
export default connect(
  (state) => ({
    SalesData: state.SalesPurchase.Sales,
    AccountData: state.SalesPurchase.Sales.account,
    Particulars: state.SalesPurchase.Sales.particulars,
  }),
  {
    SalesChangeHandler,
    SalesAddParticular,
    removeSalesParticular,
    SalesSetToDefault,
  }
)(PurchaseEntry);
